export const LOGIN = 'LOGIN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_SUBSCRIBERS = 'FETCH_SUBSCRIBER'